import type { CanvasTab } from "@/types/types";

export const LIGHTBULB_URL =
  "https://cdn.shopify.com/s/files/1/1826/6559/files/Light_bulb_Illustration.png?v=1777445842";

export const TIP_WIDTH = 340;

/** Steps of the campaign builder's design tour, consumed by `TutorialModal`. */
export const DESIGN_TOUR_STEPS = [
  {
    title: "Email Builder",
    desc: "Start here — this is the gift email your recipients will receive. The canvas on the right shows a live preview that updates as you make changes.",
    targetId: "tour-tab-email",
    canvasTab: "email" as CanvasTab,
  },
  {
    title: "Unboxing Builder",
    desc: "Next up — the unboxing video. This is the delightful moment recipients see after clicking through from the email.",
    targetId: "tour-tab-unboxing",
    canvasTab: "unboxing" as CanvasTab,
  },
  {
    title: "Landing Page Builder",
    desc: "And finally — the gift collection page. This is where recipients land after the unboxing to claim their gift.",
    targetId: "tour-tab-landing",
    canvasTab: "landing" as CanvasTab,
  },
  {
    title: "Customize",
    desc: "Customize works for whichever builder you're on — fine-tune subject lines, copy, colors, and logos across the email, unboxing, and landing page at any time.",
    targetId: "tour-customize-btn",
    canvasTab: "email" as CanvasTab,
  },
  {
    title: "Preview & Share",
    desc: "Launch a fullscreen preview of the complete gift journey, send yourself a test email to see exactly what recipients receive, or grab a shareable demo link — all from this menu.",
    targetId: "tour-preview-btn",
    canvasTab: "email" as CanvasTab,
  },
] as const;
